export enum KeyResultWeight {
  X1 = 'X1', // 1
  X2 = 'X2', // 2
  X3 = 'X3', // 3
  X4 = 'X4', // 4
  X05 = 'X05', // 0.5
  X03 = 'X033', // 0.33
  X025 = 'X025', // 0.25
}

export enum KeyResultWeightValue {
  'X1' = 1,
  'X2' = 2,
  'X3' = 3,
  'X4' = 4,
  'X05' = 0.5,
  'X033' = 0.33,
  'X025' = 0.25,
}

export enum KeyResultValueType {
  PERCENTAGE = '45f05ee8-729f-4d29-b70d-7e39c26af202',
  NUMERIC = '3ffc2688-6837-4c41-b654-76deb344e39b',
  CURRENCY = 'f87d1384-6246-4017-ba4b-5ae859e9c5ca',
}

export enum WeeklyItemStatus {
  PLANNED = 'ea14e840-66f7-460b-92e7-bd67fd321919',
  COMPLETED = '90f84e9e-53e8-48fa-9729-e3368e3821b8',
  CHALLENGE = '8d380564-bdb7-473e-903a-689861cae33c',
}
